import LabeledDatePicker from '.';
import PropTypes from 'prop-types';
import React from 'react';

const handleDateChange = ( props, name ) => date => {

    props.handleDateChange( props, name, date );

};
const LabeledDateWithRangePicker = props => (
    <div>
        <div className="inner-rows">
            <LabeledDatePicker
                className="build-date"
                selected={props.selectedFrom}
                onChange={handleDateChange( props, 'from' )}
                name={props.name}
                label="From"
                maxDate={new Date()}
                dateFormat={props.dateFormat}
            />
        </div>
        <div className="inner-rows">
            <LabeledDatePicker
                className="build-date"
                selected={props.selectedTo}
                onChange={handleDateChange( props, 'to' )}
                name={props.name}
                label="To"
                minDate={props.selectedFrom !== null ? props.selectedFrom : new Date()}
                maxDate={new Date()}
                dateFormat={props.dateFormat}
            />
        </div>
    </div>
);
LabeledDateWithRangePicker.displayName = 'LabeledDateWithRangePicker';
LabeledDateWithRangePicker.propTypes = {
    name: PropTypes.string.isRequired,
    selectedTo: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ),
    selectedFrom: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ),
    handleDateChange: PropTypes.func.isRequired,
    dateFormat: PropTypes.string,
};
export default LabeledDateWithRangePicker;
